import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import themeColors from '../../assets/styles/themeColors';
import { Heading } from '../../components/Heading';
import MetalStreamForm from '../../components/MetalStreamForm';
import OnBoardingContainer from '../../components/OnBoarding/OnBoardingContainer';
import Paragraph from '../../components/Paragraph/Paragraph';
import { useMenu } from '../../hooks/useMenu';
import { selectSettings } from '../../store/selectors/settingsSelectors';

const MetalStreamGold = () => {
  const { t } = useTranslation();
  const { activeMenu, activeItem } = useMenu();
  const { BrokerName } = useSelector(selectSettings);

  return (
    <OnBoardingContainer
      activeMenu={activeMenu}
      activeItem={activeItem}
      previousPath={activeItem?.previousPath}
    >
      <Helmet>
        <title>
          {t('metalstream.titleTagGold', {
            brokerName: BrokerName,
          })}
        </title>
      </Helmet>
      <Heading mb={12}>{t('metalstream.goldTitle')}</Heading>
      <Paragraph mb={16} color={themeColors.colorTextXLLight}>
        {t('metalstream.goldSubtitle')}
      </Paragraph>
      <MetalStreamForm
        productType="Gold"
        nextPath={activeItem?.nextPath}
        skipStepPath={activeItem?.skipPath}
      />
    </OnBoardingContainer>
  );
};

export default MetalStreamGold;
